/**
 * Merges query params onto an image URL while preserving any existing query
 * string and hash fragment. Shared canonical helper so callers don't blindly
 * append `?${params}` and clobber pre-existing params/anchors.
 */
export const withImageParams = (photoUrl: string, paramsRecord: Record<string, string>): string => {
  const hashIndex = photoUrl.indexOf('#');
  const urlWithoutHash = hashIndex === -1 ? photoUrl : photoUrl.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : photoUrl.slice(hashIndex);
  const queryIndex = urlWithoutHash.indexOf('?');
  const baseUrl = queryIndex === -1 ? urlWithoutHash : urlWithoutHash.slice(0, queryIndex);
  const currentQuery = queryIndex === -1 ? '' : urlWithoutHash.slice(queryIndex + 1);
  const params = new URLSearchParams(currentQuery);

  Object.entries(paramsRecord).forEach(([key, value]) => {
    params.set(key, value);
  });

  const query = params.toString();
  return `${baseUrl}${query ? `?${query}` : ''}${hash}`;
};
